import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { activateAppProgress, deactivateAppProgress } from './actions'

const mapDispatchToProps = {
  activateAppProgressAction: activateAppProgress,
  deactivateAppProgressAction: deactivateAppProgress
}

export default
@connect(null, mapDispatchToProps)
class AppProgressActivator extends Component {
  static propTypes = {
    activateAppProgressAction: PropTypes.func.isRequired,
    deactivateAppProgressAction: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { activateAppProgressAction } = this.props
    activateAppProgressAction(this)
  }

  componentWillUnmount() {
    const { deactivateAppProgressAction } = this.props
    deactivateAppProgressAction(this)
  }

  render() {
    return null
  }
}
